import { Injectable } from '@angular/core';
import { GenericService } from '@messaia/cdk';
import { Mail } from '../models/mail';

@Injectable({ providedIn: 'root' })
export class MailService extends GenericService<Mail> {
    /**
     * Constructor
     */
    constructor() {
        super('mail');
    }
}